import React from 'react';
import { useTranslation } from 'react-i18next';

import { displayJackpotAmount, formatCurrency } from '../../../utils/formatters';
import { isArabia, isTemplateZeta } from '../../../utils/template';
import { Route } from '../../common/Route';

import { getLotteryPlayButtonText } from 'utils/TextHelpers';

function RaffleLottery({ lottery, loading, isPlayPage }) {
    const { t } = useTranslation();
    const lotteryJackpot = lottery.jackpot || 0;
    const buttonText = getLotteryPlayButtonText(lottery, isPlayPage);

    function getBaseTemplate() {
        return (
            <div
                className={`lottery-wrapper row no-gutters text-center text-xl-left ${
                    loading ? 'loading-overlay' : ''
                }`}
            >
                <div className="lottery-wrapper-background flex-column">
                    <div className="row no-gutters">
                        <div className="col-auto d-none d-xl-block">
                            <img
                                loading="lazy"
                                className="base_ball"
                                src={lottery.ballImage}
                                alt={`${lottery.name} ${t('lotteryList.ball')}`}
                            />
                        </div>
                        <div className="col lottery-data">
                            <h2>{lottery.name || 'GG World Raffle'}</h2>
                            <h3>
                                {isTemplateZeta()
                                    ? displayJackpotAmount(lotteryJackpot, lottery.currency_code)
                                    : formatCurrency(lotteryJackpot)}
                            </h3>

                            <img
                                loading="lazy"
                                className="base_ball d-block d-xl-none"
                                src={lottery.ballImage}
                                alt={`${lottery.name} ${t('lotteryList.ball')}`}
                            />
                            {/* Adding an empty span to standardize the display since raffles lack a counter */}
                            <span className="countdown next-draw d-block">&nbsp;</span>
                        </div>
                    </div>
                    <div className="row no-gutters">
                        <div className="col">
                            <a
                                href={Route('play', { lottery: lottery.display_slug })}
                                className="btn btn-primary btn-submit d-block"
                            >
                                {t('lotteryList.play')} Raffle
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function getArabiaTemplate() {
        return (
            <div className={`lottery-wrapper row no-gutters ${loading ? 'loading-overlay' : ''}`}>
                <div className="lottery-wrapper-background flex-column">
                    <div className="row no-gutters">
                        <div className="col-auto d-none d-xl-block col-ball-image">
                            <img
                                loading="lazy"
                                className="base_ball"
                                src={lottery.ballImage}
                                alt={`${lottery.name} ${t('lotteryList.ball')}`}
                            />
                        </div>
                        <div className="col lottery-data raffle-lottery">
                            <h2>{lottery.name || 'GG World Raffle'}</h2>
                            <h3>{formatCurrency(lottery.jackpot || 0)}</h3>
                            <img
                                loading="lazy"
                                className="base_ball d-block d-xl-none"
                                src={lottery.ballImage}
                                alt={`${lottery.name} ${t('lotteryList.ball')}`}
                                data-dusk={`ball-${lottery.display_slug}`}
                            />

                            <a
                                href={Route('play', { lottery: lottery.display_slug })}
                                className="btn btn-primary btn-submit"
                            >
                                {buttonText}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function getContentByTemplate() {
        if (isArabia()) {
            return getArabiaTemplate();
        }

        return getBaseTemplate();
    }

    return getContentByTemplate();
}

export default RaffleLottery;
